import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import styles from "./HomeAbout.module.css";
import { useLang } from "../context/LanguageContext";

const HomeAbout = () => {
  const { t } = useLang();
  const ha = t.homeAbout;
  return (
  <section className={styles.section}>
    <div className={styles.inner}>

      {/* Left */}
      <motion.div
        className={styles.left}
        initial={{ opacity: 0, x: -24 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.65, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className={styles.eyebrow}>{ha.eyebrow}</p>
        <h2 className={styles.title}>
          {ha.title1}<br />
          <span className={styles.accent}>{ha.title2}</span>
        </h2>
        <p className={styles.body}>{ha.body}</p>
        <div className={styles.stack}>
          {ha.stack.map(s => <span key={s} className={styles.tag}>{s}</span>)}
        </div>
        <Link to="/about" className={styles.link}>
          {ha.link}
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </Link>
      </motion.div>

      {/* Right */}
      <motion.div
        className={styles.right}
        initial={{ opacity: 0, x: 24 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.65, ease: [0.16, 1, 0.3, 1], delay: 0.12 }}
      >
        <div className={styles.card}>
          <div className={styles.cardAccent} />
          <div className={styles.stat}>
            <span className={styles.statVal}>{ha.stat1[0]}</span>
            <span className={styles.statLabel}>{ha.stat1[1]}</span>
          </div>
          <div className={styles.divider} />
          <div className={styles.stat}>
            <span className={styles.statVal}>{ha.stat2[0]}</span>
            <span className={styles.statLabel}>{ha.stat2[1]}</span>
          </div>
          <div className={styles.divider} />
          <div className={styles.stat}>
            <span className={styles.statVal}>{ha.stat3[0]}</span>
            <span className={styles.statLabel}>{ha.stat3[1]}</span>
          </div>
          <p className={styles.cardNote}>{ha.note}</p>
        </div>
      </motion.div>

    </div>
  </section>
  );
};

export default HomeAbout;
